/* "Set it over there" — with a way to get over there.
 *
 * ERPNext refuses a lot of things by naming the setting that would allow
 * them: "Please set Standard Working Hours in HR Settings", "Please set
 * Default Cost Center in Company". The sentence is genuinely useful; the
 * link it comes with is not, because it points at ERPNext's own desk on the
 * site's internal hostname, and the gateway strips the markup around it.
 *
 * So the gateway reads the link out before stripping, and this turns it back
 * into a button to the same setting *in this app*. A refusal with nowhere to
 * go is a support ticket rather than an answer.
 */
import type { ErrorFix } from './types'

export function FixButton({ fix, onOpen }: {
  fix?: ErrorFix
  onOpen?: (doctype: string, name: string) => void
}) {
  if (!fix || !onOpen) return null
  return (
    <button className="btn btn-sm" style={{ marginTop: 8 }}
            onClick={() => onOpen(fix.doctype, fix.name)}>
      Open {fix.label}
    </button>
  )
}
